import '../components/product-modal';
import '../components/cart-add';
import '../components/wishlist-button';
import { openModal } from '../helpers/modal';
import Cart from '../services/cart';
import ProductTileSwipe from '../services/product-tile-swipe';
const checkPromotionsForSku = (tile, sku) => {
    let matchedAction = false;
    Cart.getPromotionForSKU(sku)
        .then((promotions) => {
        promotions.forEach((promotion) => {
            promotion.actions.forEach((action) => {
                if (action.type === 'product_as_gift') {
                    tile.querySelectorAll('.prod-as-gift').forEach((prodAsGiftButton) => {
                        prodAsGiftButton.innerHTML = action.settings.button_text;
                        prodAsGiftButton.style.display = 'flex';
                    });
                    matchedAction = true;
                }
            });
        });
    })
        .catch((err) => {
        console.error('Failed to get promotions for SKU', err);
    });
    if (!matchedAction) {
        tile.querySelectorAll('.prod-as-gift').forEach((prodAsGiftButton) => {
            prodAsGiftButton.style.display = 'none';
        });
    }
};
const logTileClicks = (tile) => {
    const cartAdd = tile.querySelector('cart-add');
    if (!cartAdd) {
        return;
    }
    const logUrl = cartAdd.getAttribute('logUrl');
    if (!logUrl) {
        return;
    }
    const links = tile.querySelectorAll('a');
    links.forEach((link) => {
        link.addEventListener('click', (e) => {
            if (!(e.currentTarget instanceof HTMLElement)) {
                return;
            }
            const href = e.currentTarget.getAttribute('href');
            if (href !== null) {
                e.preventDefault();
                const url = new URL(logUrl);
                url.searchParams.append('tags', JSON.stringify(['product_tile']));
                fetch(url.toString())
                    .finally(() => {
                    window.location.href = href;
                })
                    .catch((err) => {
                    console.error('Failed to log product tile click', err);
                    window.location.href = href;
                });
            }
        });
    });
};
export default (tile) => {
    if (tile === null) {
        return;
    }
    const skuMeta = tile.querySelector('meta[itemprop="sku"]');
    if (skuMeta) {
        const sku = skuMeta.getAttribute('content');
        if (sku) {
            checkPromotionsForSku(tile, sku);
            Cart.addListener((event) => {
                if (event.name === 'promotionsChanged') {
                    checkPromotionsForSku(tile, sku);
                }
            });
        }
    }
    tile.querySelectorAll('.select-color').forEach((elem) => {
        elem.addEventListener('click', (e) => {
            e.preventDefault();
            const productID = elem.getAttribute('productID');
            const sku = elem.getAttribute('sku');
            const altshopID = elem.getAttribute('altshopID');
            if (sku !== null && productID !== null && altshopID !== null) {
                openModal(`
                    <div class="header close-only">
                        <button class="close" data-micromodal-close></button>
                    </div>
                    <div class="content">
                        <product-modal sku="${sku}" productID="${productID}" altshopID="${altshopID}"></product-modal>
                    </div>
                `);
            }
            else {
                console.error('Modal could not be opened, missing sku attribute');
            }
        });
    });
    logTileClicks(tile);
    ProductTileSwipe.init(tile);
};
